// extracted by mini-css-extract-plugin
export default {"content_box":"index_content_box_-WP-7","space34":"index_space34_3-xtL","content":"index_content_t5j9s","box":"index_box_w-jIl","space30":"index_space30_DrPKR"};